import styled from '@emotion/styled'
import { Carousel } from 'antd'
import Banner01 from './assets/banner01.png'
import Banner02 from './assets/banner02.png'
import Banner03 from './assets/banner03.png'
import Banner04 from './assets/banner04.png'
import Banner05 from './assets/banner05.png'

export const Banner = () => {
    return (
        <Carousel autoplay={true} autoplaySpeed={2000}>
            <CarouselItem src={Banner01} alt={'Banner 01'} />
            <CarouselItem src={Banner02} alt={'Banner 02'} />
            <CarouselItem src={Banner03} alt={'Banner 03'} />
            <CarouselItem src={Banner04} alt={'Banner 04'} />
            <CarouselItem src={Banner05} alt={'Banner 05'} />
        </Carousel>
    );
}

const CarouselItem = styled.img`
width: 100vw;
height: 41vw;
object-fit: cover;
overflow: hidden;
`

